import { Header } from "../../header";

export default () => {
  const card = (info: any) => {
    return (
      <div className="card">
        <div className="card-header">{info.title}</div>
        <div className="card-body">
          <h5 className="card-title">{info.name}</h5>
          <h6 className="card-subtitle mb-2 text-muted">{info.subTitle}</h6>
          <p className="card-text">{info.description}</p>
          <a href="#" className="card-link">
            {info.email}
          </a>
        </div>
      </div>
    );
  };

  return (
    <div className="e-settings-layout">
      <Header title="Contact Us" showMenu={false}></Header>
      <div className="e-settings-content">
        <h3>We are open to suggestions and always welcome your feedback</h3>
        <p>
          {card({
            name: "Customer Support",
            title: "Support",
            subTitle: "Support, Features & Bugs",
            description:
              "Contact our support if you have any queries about this app",
            email: "support@optionstrategies.in",
          })}
          {card({
            name: "Anandaraj.T",
            title: "Founder",
            subTitle: "Founder, Admin & Developer",
            description:
              "Founder and developer of Option Strategy generator app",
            email: "anandarajmpec@gmail.com",
          })}
          <br />
          {card({
            name: "Basuvaraj.M",
            title: "Co-Founder, Admin & Legal advisor",
            description: "Co-founder of Option Strategy generator app",
            email: "basvarajadvocate@gmail.com",
          })}
        </p>
      </div>
    </div>
  );
};
